import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  Row,
  Col,
  notification,
  Spin,
  Card, // Import Card from Ant Design
} from "antd";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../../config";

const { Option } = Select;

const EditAdditionalInformationParent = ({ parentId, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    const values = form.getFieldsValue();
    setFullName(
      `${values.firstName || ""} ${values.surName || ""} ${
        values.lastName || ""
      }`.trim()
    );
  }, []);
  // Define enums locally
  const PhoneType = {
    0: "Mobile",
    1: "Home",
    2: "Office",
    3: "Other",
  };

  const OccupationType = {
    0: "PrivateSectorEmployee",
    1: "PublicSectorEmployee",
    2: "SelfEmployed",
    3: "Business",
    4: "Professional",
    5: "Retired",
    6: "Other",
  };
const parentType = {
  0: "Father",
  1: "Mother",
  2: "LegalGuardian",
  3: "Grandparent",
  4: "Uncle",
  5: "Aunt",
  6: "Other"
};
  // Convert enums to options format
  const phoneTypeOptions = Object.entries(PhoneType).map(([value, label]) => ({
    value: parseInt(value),
    label: label.replace(/([A-Z])/g, " $1").trim(),
  }));

  const occupationTypeOptions = Object.entries(OccupationType ).map(
    ([value, label]) => ({
      value: parseInt(value),
      label: label.replace(/([A-Z])/g, " $1").trim(),
    })
  );

  const parentTypeOptions = Object.entries(parentType).map(
    ([value, label]) => ({
      value: parseInt(value),
      label: label.replace(/([A-Z])/g, " $1").trim(),
    })
  );

  
  useEffect(() => {
    if (parentId) {
      fetchParentData();
    }
  }, [parentId]);


  const handleParentTypeChange= async (value) => {
    console.log('value',value);
    form.setFieldsValue({ parentType: value });

  };
  const handleOccupationTypeChange= async (value) => {
    console.log('value',value);
    form.setFieldsValue({ occupationType: value });

  };
  const fetchParentData = async () => {
    try {
      setLoading(true);
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        throw new Error("No user data found");
      }

      const { token } = JSON.parse(storedUser);
      const response = await fetch(
        `${API_BASE_URL}/api/ParentInformation/find/${parentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch parent information");
      }

      const data = await response.json();
      console.log("Fetched parent data:", data);

      // Convert enum values to numbers and handle null/undefined
      const formData = {
        firstName: data.firstName || "",
        surName: data.surName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        phoneNumber: data.phoneNumber || "",
        nationality: data.nationality || "",
        birthCountry: data.birthCountry || "",
        idInformationCountry: data.idInformationCountry || "",
        idNumber: data.idNumber || "",
        workPlace: data.workPlace || "",
        workPosition: data.workPosition || "",
        address: data.address || "",
        poBox: data.poBox || "",
        subCity: data.subCity || "",
        kebele: data.kebele || "",
        houseNumber: data.houseNumber || "",
        mobilePhone: data.mobilePhone || "",
        homePhone: data.homePhone || "",
        officePhone: data.officePhone || "",
        otherPhone: data.otherPhone || "",
        faxNumber: data.faxNumber || "",
        preferredPhoneType:
          data.preferredPhoneType != null ? Number(data.preferredPhoneType) : 0,
        occupationType:
          data.occupationType != null ? Number(data.occupationType) : 0,
        parentType: data.parentType != null ? Number(data.parentType) : 0,
      };

      console.log("Setting form values:", formData);
      form.setFieldsValue(formData);
    } catch (error) {
      console.error("Error fetching parent data:", error);
      notification.error({
        message: "Error",
        description: error.message || "Failed to load parent information",
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "#ff4d4f" }} />,
        style: {
          borderLeft: "4px solid #ff4d4f",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        throw new Error("No user data found");
      }

      const { token } = JSON.parse(storedUser);

      // Convert enum values to integers and ensure all field names match the backend
      const requestData = {
        // ParentId: parentId,
        // FirstName: values.firstName,
        // SurName: values.surName,
        // LastName: values.lastName,
        // PhoneNumber: values.phoneNumber,
        // Nationality: values.nationality,
        // BirthCountry: values.birthCountry,
        // IDInformationCountry: values.idInformationCountry,
        // IDNumber: values.idNumber,
        WorkPlace: values.workPlace,
        WorkPosition: values.workPosition,
        Address: values.address,
        POBox: values.poBox,
        SubCity: values.subCity,
        Kebele: values.kebele,
        HouseNumber: values.houseNumber,
        MobilePhone: values.mobilePhone,
        HomePhone: values.homePhone,
        OfficePhone: values.officePhone,
        OtherPhone: values.otherPhone,
        FaxNumber: values.faxNumber,
        PreferredPhoneType: Number(values.preferredPhoneType),
        Email: values.email,
        parentType: Number(values.parentType),
        OccupationType: Number(values.occupationType),
      };

      console.log("Sending update request with data:", requestData);
      const url = `${API_BASE_URL}/api/ParentInformation/Update/${parentId}`;
      console.log("url:", url);
      console.log("token:", token);

      const response = await fetch(
        `${API_BASE_URL}/api/ParentInformation/Update/${parentId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const responseData = await response.json();
      console.log("Update response:", responseData);

      if (!response.ok) {
        throw new Error(
          responseData.message || "Failed to update parent information"
        );
      }

      notification.success({
        message: "Update Successful",
        description: "Parent information has been updated successfully",
        placement: "topRight",
        duration: 3,
        icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        style: {
          borderLeft: "4px solid #52c41a",
        },
      });
      onClose();
    } catch (error) {
      console.error("Update error:", error);
      notification.error({
        message: "Update Failed",
        description: error.message || "Failed to update parent information",
        placement: "topRight",
        duration: 4,
        icon: <InfoCircleOutlined style={{ color: "#ff4d4f" }} />,
        style: {
          borderLeft: "4px solid #ff4d4f",
        },
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <Card
      title={fullName} 
      style={{
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Spin spinning={loading}>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Parent Type"
                name="parentType"
                rules={[
                  { required: true, message: "Please select parent type" },
                ]}
              >
                <Select
                  placeholder="Select parent type"
                  onChange={handleParentTypeChange}

                  options={parentTypeOptions}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="phoneNumber" label="Primary Phone Number">
                <Input readOnly />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
          <Col span={8}>
              <Form.Item
                name="email"
                label="Additional Email (if needed)"
                rules={[
                  { required: false, message: "Please enter email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="workPlace"
                label="Work Place"
                rules={[
                  { required: false, message: "Please enter work place" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="workPosition"
                label="Work Position"
                rules={[
                  { required: false, message: "Please enter work position" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: false, message: "Please enter address" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="poBox"
                label="P.O. Box"
                rules={[{ required: false, message: "Please enter P.O. Box" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="subCity"
                label="Sub City"
                rules={[{ required: false, message: "Please enter sub city" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="kebele"
                label="Kebele"
                rules={[{ required: false, message: "Please enter kebele" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="houseNumber"
                label="House Number"
                rules={[
                  { required: false, message: "Please enter house number" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="mobilePhone"
                label="Mobile Phone"
                rules={[
                  { required: false, message: "Please enter mobile phone" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>

            <Col span={8}>
              <Form.Item
                name="homePhone"
                label="Home Phone"
                rules={[
                  { required: false, message: "Please enter home phone" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="officePhone"
                label="Office Phone"
                rules={[
                  { required: false, message: "Please enter office phone" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="otherPhone"
                label="Other Phone"
                rules={[
                  { required: false, message: "Please enter other phone" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="faxNumber"
                label="Fax Number"
                rules={[
                  { required: false, message: "Please enter fax number" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Preferred Phone Type"
                name="preferredPhoneType"
                rules={[
                  {
                    required: true,
                    message: "Please select preferred phone type",
                  },
                ]}
              >
                <Select
                  placeholder="Select preferred phone type"
                  options={phoneTypeOptions}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Occupation Type"
                name="occupationType"
                rules={[
                  { required: true, message: "Please select occupation type" },
                ]}
              >
                <Select
                  placeholder="Select occupation type"
                  onChange={handleOccupationTypeChange}
                 
                  options={occupationTypeOptions}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end">
            <Space>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save Changes
              </Button>
            </Space>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
};

export default EditAdditionalInformationParent;
